import React, { useMemo } from 'react';
import { Autocomplete, TextField, Checkbox } from '@mui/material';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

// TODO: Future enhancement - replace with API call to fetch roles dynamically
// This hardcoded list will be replaced with useApiGet when backend endpoint is ready
const LOCAL_CHAPTER_ROLES = [
  {
    id: 'c8094b8d6c514c219f4a5bbdd2c72b6b',
    name: 'Local Chapter President',
    order: 70,
  },
  {
    id: '98619508202847c8adc15a4b11a079f7',
    name: 'Local Chapter Vice President',
    order: 71,
  },
  {
    id: '070e1690d8de4854bb22a3b35bd3742b',
    name: 'Local Chapter Recording Secretary',
    order: 72,
  },
  {
    id: 'dc10f6cbd8e94070bb73b4685b5e84b8',
    name: 'Local Chapter Corresponding Secretary',
    order: 73,
  },
  {
    id: 'cc32bed8f4784291b0424e830f0c8cc7',
    name: 'Local Chapter Treasurer',
    order: 74,
  },
  {
    id: '888c4b116aae46e496c1f2c8ad9feb34',
    name: 'Local Chapter Chaplain',
    order: 75,
  },
  {
    id: '8af77101465e4650a6af36bbc183f142',
    name: 'Local Chapter Guard',
    order: 76,
  },
  {
    id: '0063de12834544deaebed87d985638ff',
    name: 'Local Chapter Membership Chair',
    order: 77,
  },
  {
    id: '4f55953df0b04bc9b76a775c420a8460',
    name: 'Local Chapter Technology Contact',
    order: 78,
  },
];

interface Role {
  id: string;
  name: string;
  order: number;
}

interface LocalChapterRolesFilterProps {
  value: string; // Comma-separated role IDs
  onChange: (value: string) => void;
  disabled?: boolean;
  required?: boolean;
}

const LocalChapterRolesFilter: React.FC<LocalChapterRolesFilterProps> = ({
  value,
  onChange,
  disabled = false,
  required = false,
}) => {
  // Parse comma-separated string into array of role objects
  const selectedRoles = useMemo(() => {
    if (!value) return [];
    const roleIds = value
      .split(',')
      .map((id) => id.trim())
      .filter(Boolean);
    return LOCAL_CHAPTER_ROLES.filter((role) => roleIds.includes(role.id));
  }, [value]);

  const handleChange = (_event: any, newValue: Role[]) => {
    // Convert selected role objects back to comma-separated ID string
    const roleIdsString = newValue.map((role) => role.id).join(',');
    onChange(roleIdsString);
  };

  return (
    <Autocomplete
      multiple
      id="local-chapter-roles-filter"
      options={LOCAL_CHAPTER_ROLES}
      disableCloseOnSelect
      disabled={disabled}
      value={selectedRoles}
      onChange={handleChange}
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      renderOption={(props, option, { selected }) => (
        <li {...props}>
          <Checkbox
            icon={icon}
            checkedIcon={checkedIcon}
            style={{ marginRight: 8 }}
            checked={selected}
          />
          {option.name}
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Officer Roles"
          placeholder="Select roles..."
          required={required}
          size="small"
        />
      )}
    />
  );
};

export default LocalChapterRolesFilter;
